module.exports = __webpack_public_path__ + "static/img/max_pictgrid17_980x862.f5035de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid17_980x862.jpg
// module id = Jv6U
// module chunks = 0